import type { UpdateTopicsFilterAction } from "domains/monitor/filter/actionTypes";
import { MonitorFilterActionType } from "domains/monitor/filter/actionTypes";

export const updateTopicsFilter = (selectedTopics?: string[]): UpdateTopicsFilterAction => ({
  type: MonitorFilterActionType.UPDATE_FILTER,
  payload: { selectedTopics },
});
